import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        stroke: "#667085",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.67",
        d: "M14.167.833 17.5 4.166m0 0L14.167 7.5M17.5 4.166H5.833A3.333 3.333 0 0 0 2.5 7.5v1.666m3.333 10L2.5 15.833m0 0L5.833 12.5M2.5 15.833h11.667A3.333 3.333 0 0 0 17.5 12.5v-1.667"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h20v20H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }